<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">
          {{ $tc("cinema", 1) }} {{ $t("loyaltysettings") }}
        </div>
        <div class="section-subTitle my-2">
          {{ $t("manage") }} {{ $t("all") }} {{ $t("loyalty") }}
        </div>
      </div>
      <div v-if="matchedCinema">
        <b-button
          v-if="$can('create', 'Cinema Loyalty Settings')"
          variant="default"
          to="add-cinema-loyalty-settings"
          class="btn-blue"
          >{{ $t("add") }}</b-button
        >
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-debounce:300="getCinemaloyaltysettings"
          v-model="searchValue"
          :placeholder="$tc('searchs')"
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <FilterByStatusDropdown
          :onSelect="
            (filterIsActive) => {
              getCinemaloyaltysettings(filterIsActive);
            }
          "
        />
        <div class="mx-2">
          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- {{ $t("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;{{ $t("of") }}&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <!-- LIST VIEW DESIGNATION -->
    <div class="desg-list-container">
      <div class="desg-list-header">
        <div class="pr-3" style="width: 150px">{{ $tc("status", 2) }}</div>
        <div class="">
          <img
            v-if="this.columnName != 'cine_name'"
            @click="onSortValue('cine_name', 'asc')"
            src="@/assets/img/icons/updown.svg"
            class="cursor-pointer"
            width="15px"
            height="20px"
          />
          <img
            v-else-if="isSort && isAscending"
            @click="onSortValue('cine_name', 'asc')"
            src="@/assets/img/icons/asc.svg"
            class="cursor-pointer"
            width="15px"
            height="20px"
          />
          <img
            v-else
            @click="onSortValue('cine_name', 'desc')"
            src="@/assets/img/icons/desc.svg"
            class="cursor-pointer"
            width="15px"
            height="20px"
          />
          {{ $tc("cinema", 1) }} {{ $t("loyaltysettings") }} {{ $t("name") }}
        </div>
      </div>
      <ul
        v-if="CinemaloyaltysettingsList && CinemaloyaltysettingsList.length > 0"
        class="desg-list"
      >
        <li
          v-for="(
            cinemaloyaltylist, cinemaloyaltylistIndex
          ) in CinemaloyaltysettingsList"
          :key="cinemaloyaltylistIndex"
        >
          <!-- <div class="d-flex align-items-center">
            <StatusDot
              :status="
                cinemaloyaltylist.cls_is_active === 'Y'
                  ? 'active'
                  : cinemaloyaltylist.cls_is_active === 'N' && 'inactive'
              "
            />
            <b-dropdown right variant="edit" class="ml-4">
              <b-dropdown-item
                v-if="$can('update', 'Cinema Loyalty Settings')"
                @click.prevent.stop="gotoRoute(cinemaloyaltylist, 'Edit')"
              >
                <span class="edit-pen mr-1"></span>
                {{ $t("edit") }}
              </b-dropdown-item>
              <b-dropdown-item
                @click.prevent.stop="gotoRoute(cinemaloyaltylist, 'View')"
              >
                <span class="icon-eye mr-1"></span>
                {{ $t("view") }}
              </b-dropdown-item>
            </b-dropdown>
          </div> -->
          <div class="d-flex align-items-center" style="width: 150px">
            <StatusDot
              :status="
                cinemaloyaltylist.cls_is_active === 'Y'
                  ? 'active'
                  : cinemaloyaltylist.cls_is_active === 'N' && 'inactive'
              "
            />
            <i
              v-if="$can('update', 'Cinema Loyalty Settings')"
              class="edit-pen icon blue-icon cursor-pointer ml-4"
              @click.prevent.stop="gotoRoute(cinemaloyaltylist, 'Edit')"
              v-b-tooltip="'Edit'"
              tabindex="0"
            ></i>
            <i
              class="icon-eye blue-icon cursor-pointer ml-2"
              @click.prevent.stop="gotoRoute(cinemaloyaltylist, 'View')"
              v-b-tooltip="'View'"
              tabindex="0"
            ></i>
          </div>

          <div>
            {{ cinemaloyaltylist.cine_name }}
          </div>
        </li>
      </ul>

      <ul v-else class="desg-list">
        <li class="pb-3">
          <NoRecords classes="mb-0" />
        </li>
      </ul>
    </div>
    <br />
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MarketingService from "@/services/MarketingService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      gridView: false,
      listView: true,
      cine_id: "",
      CinemaloyaltysettingsList: [],
      matchedCinema: true,

      debounce: null,
      searchValue: "",

      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",
    };
  },
  beforeMount() {
    this.cine_id = this.secureStore.get("USINFO").cinema_id;
    this.getviewingnumber();
    this.getCinemaloyaltysettings();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    gotoRoute: function (data, type) {
      if (type == "Edit") {
        this.$router.push({
          path: "/marketing/edit-cinema-loyalty-settings",
          query: { cls_id: data.cls_id },
        });
      } else {
        this.$router.push({
          path: "/marketing/view-cinema-loyalty-settings",
          query: { cls_id: data.cls_id },
        });
      }
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getCinemaloyaltysettings();
      } else {
        this.currentPage = event;
        this.getCinemaloyaltysettings();
      }
    },

    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getCinemaloyaltysettings();
    },
    getCinemaloyaltysettings: function (filterIsActive = "Y") {
      this.CinemaloyaltysettingsList = [];
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderby,
        searchValue: this.searchValue,
        cinema_id:
          this.cine_id && String(this.cine_id).length > 0 ? this.cine_id : null,
        filter_is_active: filterIsActive,
      };

      MarketingService.getcinemaloyaltysettingsList(payload)
        .then((response) => {
          const { data } = response;

          if (data.status) {
            if (data.Records && data.Records.length > 0) {
              this.CinemaloyaltysettingsList = data.Records;

              this.CinemaloyaltysettingsList.map((x) => {
                if (x.cine_id == this.cine_id) {
                  this.matchedCinema = false;
                }
              });

              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                // this.selectedvalue = data.totalRows;
              }
            } else {
              this.$toasted.show(data.message);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/LoyaltySettingsComponents/listcinemaloyaltysettings.vue